import classNames from "classnames";
import React, { useState, useCallback } from "react";

interface ThrottleButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  throttleTimeInMs?: number;
  children: React.ReactNode;
  classList?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

const ThrottleButton: React.FC<ThrottleButtonProps> = ({
  onClick,
  throttleTimeInMs = 1000,
  children,
  disabled,
  classList,
  type = "button",
}) => {
  const [isThrottled, setIsThrottled] = useState(false);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (!isThrottled) {
        onClick(e);
        setIsThrottled(true);
        setTimeout(() => setIsThrottled(false), throttleTimeInMs);
      }
    },
    [isThrottled, onClick, throttleTimeInMs]
  );

  return (
    <button
      className={classNames(classList, {
        disabled: disabled,
        loading: isThrottled,
      })}
      onClick={handleClick}
      disabled={isThrottled || disabled}
      type={type}
    >
      {children}
    </button>
  );
};

export default ThrottleButton;
